module.exports = __webpack_public_path__ + "img/2_2-finanziario-filiale-1.6b5bc4c5.png";